<template>
  <section>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <b-modal v-model="show" :width="1000" scroll="keep" :on-cancel="closeModal">
      <div class="modal-widget" id="#create_device_cotainer">
        <div class="modal-title">
          <h2 class="title">Agregar de dispositivo</h2>
        </div>
        <div class="modal-body">
          <div class="form-container">
            <div class="columns">
              <div class="column">
                <CompanySelector v-model="company" />
              </div>
              <div class="column">
                <b-field label="Tipo de dispositivo *">
                  <b-select
                    placeholder="Tipo de disposiitvo"
                    expanded
                    v-model="deviceType"
                    name="deviceType"
                  >
                    <option
                      v-for="option in deviceTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Nombre de dispositivo  *">
                  <b-input
                    placeholder="Nombre de dispositivo"
                    type="text"
                    name="deviceName"
                    v-model="deviceName"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field label="IMEI o MAC de dispositivo  *">
                  <b-input
                    placeholder="IMEI o MAC de dispositivo"
                    type="text"
                    name="imei"
                    v-model="imei"
                  />
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Tecnología de dispositivo  *">
                  <b-select
                    placeholder="Tecnología de dispositivo"
                    expanded
                    v-model="technology"
                    name="technology"
                  >
                    <option
                      v-for="option in technologies"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Tiempo de gracia">
                  <b-input
                    placeholder="Tiempo de gracia"
                    type="number"
                    name="graceTime"
                    v-model="graceTime"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field label="Consecutivo de ingreso">
                  <b-input
                    placeholder="Consecutivo de ingreso"
                    type="number"
                    name="initialValue"
                    v-model="initialValue"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field label="Resoluciones">
                  <b-select
                    placeholder="Resoluciones"
                    expanded
                    v-model="resolution"
                    name="resolution"
                  >
                    <option
                      v-for="option in resolutions"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                    >
                      {{ option.company.name }}
                    </option>
                  </b-select>
                </b-field>
                <span class="show-error">{{
                  errors.first("classification")
                }}</span>
              </div>
            </div>
          </div>
          <div class="apps-permises-container">
            <div class="columns pt-3 pb-3 flex-center" v-if="loadingModules">
              <Loader />
            </div>
            <template v-if="!loadingModules">
              <div class="columns device-modules">
                <div
                  class="column"
                  v-for="(moduleGroup, moduleIndex) in moduleGroups"
                  :value="moduleGroup.app.code"
                  :key="moduleGroup.app.code"
                  :id="moduleGroup.app.code"
                >
                  <div class="group-container">
                    <div class="group-header">
                      <vs-checkbox
                        class="justify-content-start checkbox-item"
                        v-model="$data.moduleGroups[moduleIndex].selected"
                        v-on:change="onChangeCheckModule(moduleGroup)"
                      >
                        {{ moduleGroup.app.title }}
                      </vs-checkbox>
                    </div>
                    <div class="group-body">
                      <ul class="activities-container">
                        <li
                          class="activity-item"
                          v-for="(
                            activity, activityIndex
                          ) in moduleGroup.activities"
                          :value="activity.code"
                          :key="activityIndex"
                          :id="activity.code"
                        >
                          <vs-checkbox
                            class="justify-content-start checkbox-item"
                            v-on:change="onChangeCheckModule(activity)"
                            :disabled="
                              !$data.moduleGroups[moduleIndex].selected
                            "
                            v-model="
                              $data.moduleGroups[moduleIndex].activities[
                                activityIndex
                              ].selected
                            "
                          >
                            {{ activity.title }}
                          </vs-checkbox>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="columns">
            <div class="column text-right">
              <vs-button
                color="danger"
                type="filled"
                class="pl-5 pr-5"
                icon="close"
                @click="closeModal"
                >Cancelar</vs-button
              >
              <vs-button
                color="success"
                class="ml-3 pl-5 pr-5"
                icon="save"
                type="filled"
                @click="saveDevice"
                :disabled="validate()"
              >
                Guardar
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import CompanySelector from "../../../components/Shared/CompanySelector";
import Loader from "../../../components/Shared/Loader.vue";
import { ROUTES } from "../../../global/api_routes";
import { TOAST_TYPES, configToast } from "../../../global/toast";
import { DETAILS_STATUS, STATUS } from "../../../global/constants";
import { validArray, sortByKeyName } from "../../../global/utils";
import { validator } from "../../../global/validator";
import { ActivityType } from "../../../global/constants";

export default {
  components: { CompanySelector, Loader },
  data: () => ({
    isLoading: false,
    activities: [],
    loadingModules: false,
    show: false,
    company: null,
    deviceType: null,
    deviceName: null,
    imei: null,
    graceTime: null,
    resolution: null,
    technology: null,
    initialValue: null,
    technologies: [],
    deviceTypes: [],
    resolutions: [],
    moduleGroups: [],
    deviceActivities: [],
    deviceId: null,
  }),
  watch: {
    company: function (company) {
      if (company == null) {
        return;
      }
      this.loadingModules = true;
      this.getResolution(company);
      this.getModuleGroups(company);
    },
    moduleGroups: function () {
      if (
        !this.loadingModules ||
        this.moduleGroups === null ||
        !validArray(this.moduleGroups, 1) ||
        !this.deviceId
      ) {
        this.loadingModules = false;
        return;
      }
      this.findDeviceActivities();
    },
  },
  mounted() {
    this.getTecnnologies();
    this.getDeviceTypes();
  },
  methods: {
    onChangeCheckModule(object) {
      if (object.activities) {
        const list = [...this.moduleGroups];
        this.moduleGroups = list.map((group) => {
          if (group.app.code == object.app.code) {
            group.timestamp = new Date().getTime();
            group.activities = group.activities.map((activity) => {
              return { ...activity, deleted: !object.selected };
            });
          }
          return group;
        });
        return;
      }
    },
    setData({
      deviceId,
      company,
      deviceType,
      deviceName,
      imei,
      technology,
      graceTime,
      initialValue,
      resolution,
    }) {
      this.deviceId = deviceId;
      this.company = company;
      this.deviceType = deviceType;
      this.deviceName = deviceName;
      this.imei = imei;
      this.technology = technology;
      this.graceTime = graceTime;
      this.initialValue = initialValue;
      this.resolution = resolution;
      this.getResolution(company);
      this.getModuleGroups(company);
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#create_device_cotainer");
      return instance.open(message, type);
    },
    validate() {
      const rules = [
        { field: "company" },
        { field: "deviceType" },
        { field: "deviceName", minLength: 3 },
        { field: "imei", minLength: 15 },
        { field: "technology" },
      ];
      const { result, errors } = validator(this, rules);
      return !result;
    },
    replaceActivities({ app, actionType, keyName, initialsText = null }) {
      const index = app.activities.findIndex(
        (activity) =>
          activity.actionType === actionType && !activity.originalActivity
      );
      const activity = index >= 0 ? app.activities[index] : null;
      let list = [];
      if (index >= 0 && Array.isArray(activity[keyName])) {
        app.activities.splice(index, 1);
      }
      if (!initialsText && activity && actionType === activity.actionType) {
        app.activities = app.activities.concat(
          activity[keyName].map((item) => {
            return {
              ...item,
              keyListName: keyName,
              originalActivity: activity,
            };
          })
        );
      }
      if (Array.isArray(initialsText) && activity) {
        initialsText.forEach((initText) => {
          list = list.concat(
            activity[keyName].map((item) => {
              return {
                ...item,
                keyListName: keyName,
                listNameType: initText.code,
                title: `${initText.text}${initText.text ? " " : ""}${
                  item.title
                }`,
                originalActivity: activity,
              };
            })
          );
        });
      }
      app.activities = sortByKeyName(app.activities.concat(list), "title");
    },
    parseModules(list = []) {
      list.forEach((app) => {
        this.replaceActivities({
          app,
          actionType: ActivityType.VOUCHER,
          keyName: "vouchers",
        });
        this.replaceActivities({
          app,
          actionType: ActivityType.VEHICLE_TYPES,
          keyName: "vehicleTypes",
          initialsText: [
            { code: "entry", text: "Ingreso de" },
            { code: "out", text: "Salida de" },
          ],
        });
        this.replaceActivities({
          app,
          actionType: ActivityType.PAY_TYPES,
          keyName: "vehicleTypes",
          initialsText: [{ code: "pay", text: "Pago de " }],
        });
      });
      return list;
    },
    getModuleGroups(companyId) {
      this.loadingModules = true;
      this.$http
        .post(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_MODULE_GROUPS, {
          companyId: companyId,
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.moduleGroups = this.parseModules(data.info);
          }
        })
        .finally(() => {
          this.loadingModules = false;
        });
    },
    getDeviceData() {
      const activities = [];
      this.moduleGroups.forEach((moduleGroup) => {
        moduleGroup.activities.forEach((activity) => {
          if (
            (activity.selected && !activity.saved) ||
            (activity.saved && !activity.selected) ||
            (activity.saved && activity.deleted)
          ) {
            const status =
              activity.selected && !activity.deleted
                ? STATUS.ACTIVE
                : STATUS.DELETED;
            const activityObj = activity.originalActivity
              ? {
                  ...activity.originalActivity,
                  keyListName: activity.keyListName,
                  listNameType: activity.listNameType,
                  codeListItem: activity.code,
                  status: status,
                }
              : { ...activity, status: status };

            activities.push(activityObj);
          }
        });
      });
      return {
        code: this.deviceId,
        company: { code: this.company },
        title: this.deviceName,
        id: this.imei,
        deviceType: { code: this.deviceType },
        technology: this.technology,
        graceTime: this.graceTime,
        initialValue: this.initialValue,
        activities: activities,
        enumeration: this.resolution,
      };
    },
    saveDevice() {
      const obj = this.getDeviceData();
      this.isLoading = true;
      this.$http
        .post(ROUTES.DASHBOARD.CONFIG_DEVICES.SAVE_DEVICE, obj)
        .then(({ data }) => {
          if (data.code > 0) {
            this.toast(
              "Se ha registrado correctamente el dispositivo",
              TOAST_TYPES.SUCCESS
            );
            this.closeModal();
            this.$emit("updatedDevice", obj);
            return;
          }
          this.toast(
            "Se ha producido un error al registrar el dispositivo",
            TOAST_TYPES.ERROR
          );
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    autoSelectActivities() {
      this.moduleGroups.forEach((group) => {
        group.activities = group.activities.map((activity) => {
          const exist = this.deviceActivities.find((deviceActivity) => {
            const equalActivityCode =
              deviceActivity.activity.code === activity.code;

            const value = deviceActivity.value
              ? JSON.parse(deviceActivity.value)
              : null;

            const codeListItem = value ? parseInt(value.codeListItem) : null;

            const keyListName = value ? value.keyListName : null;

            const listNameType = value ? value.listNameType : null;

            const equalDinamicItemCode =
              codeListItem === activity.code &&
              deviceActivity.activity.app === group.app.code &&
              keyListName == activity.keyListName &&
              listNameType === activity.listNameType;

            return equalActivityCode || equalDinamicItemCode;
          });
          if (exist) {
            activity.selected = true;
            activity.saved = true;
            group.selected = true;
          }
          return activity;
        });
      });
    },
    findDeviceActivities() {
      const deviceId = this.deviceId;
      this.$http
        .post(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICES_ACTIVED, {
          deviceId: deviceId,
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.deviceActivities = data.info;
            this.autoSelectActivities();
          }
        })
        .finally(() => {
          this.loadingModules = false;
        });
    },
    openModal() {
      this.show = true;
    },
    closeModal() {
      this.deviceId = null;
      this.show = false;
      this.company = null;
      this.deviceName = null;
      this.imei = null;
      this.deviceTetch = null;
      this.graceTime = null;
      this.technology = null;
      this.initialValue = null;
      this.resolution = null;
      this.moduleGroups = [];
      this.deviceActivities = [];
    },
    getTecnnologies() {
      this.$http
        .get(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_TECHNOLOGIES)
        .then(({ data }) => {
          if (data.code > 0) {
            this.technologies = data.info;
          }
        });
    },
    getDeviceTypes() {
      this.$http
        .get(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICE_TYPES)
        .then(({ data }) => {
          if (data.code > 0) {
            this.deviceTypes = data.info;
          }
        });
    },
    getResolution(id) {
      this.$http
        .get(ROUTES.DASHBOARD.RESOLUTION.GET_RESOLUTION, {
          params: {
            companyId: id,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.resolutions = data.info;
          }
        });
    },
  },
};
</script>

<style>
.modal-widget {
  background-color: #ffffff;
  border-radius: 5px;
  height: auto;
  margin: 0 auto;
  padding: 15px;
}
.modal-widget .btn-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 0;
  box-shadow: none;
  font-size: 1.2em;
  background-color: #f64651;
  color: #ffffff;
}
.modal-widget .btn-close:hover {
  background-color: black;
  color: #ffffff;
}
.modal-widget .modal-title {
  display: block;
  height: 25px;
  text-align: left;
  padding: 10px 15px;
  padding-bottom: 30px;
}
.modal-widget .modal-title .title {
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
}
.modal-widget .modal-body {
  display: block;
}
.group-container .group-header {
  padding: 5px 0px;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 10px;
}
.checkbox-item {
  padding: 5px 0;
}
.checkbox-item span {
  font-weight: bold;
}
.checkbox-item .vs-checkbox {
  border-color: #1d76fb !important;
}
.columns.device-modules {
  flex-direction: column;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  background-color: #fafafa;
  margin-bottom: 15px;
}
.columns.device-modules .activities-container {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  padding: 0 20px;
}
.columns.device-modules .con-slot-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 25px);
}
</style>
